import Styles from "./FormDescription.module.scss";

type Props = {
	children: string;
};

export function FormDescription({ children }: Props) {
	return <p className={Styles.FormDescription}>{children}</p>;
}
